import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { WizardStep } from 'foundations-components/transitional/components/Wizard';
import { Fragment, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getServices } from '../../../slices/serviceCatalogSlice';
import PillButton from './FindPartnerWizardPillButton';
// @ts-expect-error untyped module
import { isQa } from '../../../utils/env';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';

// TODO: MISSING "CUSTOMER INTEGRATIONS"
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const POPULAR_SERVICE_IDS = isQa() ? [1290, 1309, 1308, 1301, 1298, 48553, 1288, 1297, 1305] : [5, 24, 23, 16, 13, 39001, 3, 12, 20];
function SelectItem({
  children,
  option
}) {
  const {
    brief
  } = option;
  const showTooltip = !!brief && !Object.keys(option).includes('help');
  if (!showTooltip) {
    return /*#__PURE__*/_jsx("span", {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "row",
    justify: "between",
    paddingInlineEnd: "400",
    children: [children, /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: brief,
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "do-not-use-flint",
        size: "600"
      })
    })]
  });
}
export default function FindPartnerWizardServiceStep({
  filters,
  onFilterChange
}) {
  const services = useSelector(getServices);
  const [showMore, setShowMore] = useState(false);
  const options = useMemo(() => services.map(service => ({
    brief: service.brief,
    text: service.name,
    value: service.id
  })), [services]);
  const renderedPopularServices = useMemo(() => {
    const result = POPULAR_SERVICE_IDS.filter(id => !filters.service.includes(id)).map(id => services.find(service => service.id === id));
    const expandable = result.length > 5;
    if (result.length < 5) {
      setShowMore(false);
    }
    if (!showMore) {
      result.splice(5);
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!!result.length && /*#__PURE__*/_jsx(Text, {
        as: "h7",
        marginBlockStart: "700",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.popularServices"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexWrap: "wrap",
        gap: "200",
        children: result.map(service => /*#__PURE__*/_jsx(PillButton, {
          onClick: () => onFilterChange('service', [...filters.service, service.id]),
          tooltipTitle: service.brief,
          children: service.name
        }, service.id))
      }), !showMore && expandable && /*#__PURE__*/_jsx(Button, {
        onClick: () => setShowMore(true),
        use: "link",
        paddingBlockStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.seeMore"
        })
      })]
    });
  }, [filters, onFilterChange, services, showMore]);
  return /*#__PURE__*/_jsxs(WizardStep, {
    children: [/*#__PURE__*/_jsx(Text, {
      "data-test-id": "findPartnerWizard-step-1",
      as: "h2",
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.service.title"
      })
    }), /*#__PURE__*/_jsx(Select, {
      anchorType: "combined",
      itemComponent: SelectItem,
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => onFilterChange('service', value),
      multi: true,
      value: filters.service
    }), renderedPopularServices]
  });
}